import axios from "axios";
import { config } from '@/helpers/environment.helper';
import { CardPayInRequest } from "@/types/payment";

export const paymentApi = axios.create({
  baseURL: config.middlewareURL,
  timeout: 100000,
  withCredentials: true,
});

export const getPaymentMethodsCardsWithApiKey = async () => {
  return paymentApi.get('/api/v1/payment/paymentMethods/cards')
};

export const postPaymentMethodsCreditCardWithApiKey = () => {
  return paymentApi.post('/api/v1/payment/paymentMethods/card')
}

export const postPaymentMethodsBankwire = (amount: number) => {
  return paymentApi.post('/api/v1/payment/bankwire', { amount })
}

export const postCreditCardPaymentWithApiKey =  async (
  amount: number,
  returnUrl: string,
  cardId: string,
  javaEnabled: boolean,
  language: string,
  colorDepth: number,
  screenHeight: number,
  screenWidth: number,
  timezoneOffset: string,
  userAgent: string
): Promise<CardPayInRequest> => {
  return await paymentApi.post('/api/v1/payment/cardDirect', {
    amount,
    returnUrl,
    cardId,
    javaEnabled,
    language,
    colorDepth,
    screenHeight,
    screenWidth,
    timezoneOffset,
    userAgent
  })
};

export const patchCreditCardPaymentWithApiKey = async (transactionId: string) => {
  try {
    const res = await paymentApi.patch('/api/v1/payment/card', {
      transactionId
    })
    if (!res) return null;
    return true;
  } catch (err: any) {
    console.log(err)
    if (err.response && err.response.status === 412) return false;
    return err.response;
  }
}

export const patchPaymentMethodsCreditCardWithApiKey = (
  registrationData: any,
  registrationId: string,
  saveCard: boolean
) => {
  return paymentApi.patch('/api//v1/payment/paymentMethods/card', { registrationData, registrationId, saveCard })
}
